module.exports = __webpack_public_path__ + "img/ics_f_min_circle.5938671b.svg";